var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWireTransfer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6543 15.8243C4.6543 16.2811 5.00492 16.6495 5.44055 16.6495H6.32951C6.70846 16.6495 7.01659 16.3272 7.01659 15.9305C7.01659 15.4984 6.82888 15.3461 6.54909 15.247L5.1218 14.7511C4.84201 14.652 4.6543 14.4997 4.6543 14.0676C4.6543 13.6709 4.96242 13.3486 5.34138 13.3486H6.23034C6.66596 13.3486 7.01659 13.717 7.01659 14.1738",
    stroke: "#4F5372",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83203 12.875V17.125V12.875Z",
    fill: "#4F5372"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83203 12.875V17.125",
    stroke: "#4F5372",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83268 18.5413C7.78869 18.5413 9.37435 16.9557 9.37435 14.9997C9.37435 13.0437 7.78869 11.458 5.83268 11.458C3.87667 11.458 2.29102 13.0437 2.29102 14.9997C2.29102 16.9557 3.87667 18.5413 5.83268 18.5413Z",
    stroke: "#4F5372",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5008 18.9579C12.2758 18.9579 12.0675 18.8329 11.9591 18.6412C11.8508 18.4412 11.8508 18.2079 11.9675 18.0079L12.8425 16.5495C13.0175 16.2579 13.4008 16.1579 13.7008 16.3329C14.0008 16.5079 14.0925 16.8912 13.9175 17.1912L13.6925 17.5662C15.9925 17.0245 17.7175 14.9579 17.7175 12.4912C17.7175 12.1495 18.0008 11.8662 18.3425 11.8662C18.6842 11.8662 18.9675 12.1495 18.9675 12.4912C18.9592 16.0579 16.0592 18.9579 12.5008 18.9579Z",
    fill: "#4F5372"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 8.12533C1.32435 8.12533 1.04102 7.84199 1.04102 7.50033C1.04102 3.94199 3.94102 1.04199 7.49935 1.04199C7.72435 1.04199 7.9327 1.16699 8.04104 1.35866C8.14937 1.55866 8.14936 1.79199 8.0327 1.99199L7.15771 3.45033C6.98271 3.74199 6.59935 3.84199 6.29935 3.66699C5.99935 3.49199 5.90767 3.10866 6.08267 2.80866L6.30769 2.43366C4.00769 2.97532 2.28267 5.04199 2.28267 7.50866C2.29101 7.84199 2.00768 8.12533 1.66602 8.12533Z",
    fill: "#4F5372"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.13 1.5804L18.255 2.8304C18.3765 2.87901 18.4737 3.02484 18.4737 3.15331V4.30609C18.4737 4.49706 18.3175 4.65331 18.1265 4.65331H11.8765C11.6855 4.65331 11.5293 4.49706 11.5293 4.30609V3.15331C11.5293 3.02484 11.6265 2.87901 11.748 2.8304L14.873 1.5804C14.9425 1.55263 15.0605 1.55263 15.13 1.5804Z",
    stroke: "#4F5372",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4737 8.47287H11.5293V7.43121C11.5293 7.24023 11.6855 7.08398 11.8765 7.08398H18.1265C18.3175 7.08398 18.4737 7.24023 18.4737 7.43121V8.47287Z",
    stroke: "#4F5372",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2227 7.08095V4.65039",
    stroke: "#4F5372",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0781 7.08095V4.65039",
    stroke: "#4F5372",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9336 7.08095V4.65039",
    stroke: "#4F5372",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7891 7.08095V4.65039",
    stroke: "#4F5372",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1816 8.47266H18.8205",
    stroke: "#4F5372",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0013 3.78483C15.289 3.78483 15.5221 3.55165 15.5221 3.264C15.5221 2.97635 15.289 2.74316 15.0013 2.74316C14.7137 2.74316 14.4805 2.97635 14.4805 3.264C14.4805 3.55165 14.7137 3.78483 15.0013 3.78483Z",
    fill: "#4F5372"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWireTransfer);
export default __webpack_public_path__ + "static/media/wire-transfer.ea73221e878a7e46a1963129efdd231a.svg";
export { ForwardRef as ReactComponent };